import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Box, Button, IconButton, Typography } from '@mui/material';
import IncTextField from 'components/forms/fields/inc-text-field/inc-text-field.component';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useWatch, useFormContext } from 'react-hook-form';

const AddEditAttributesForm = ({ customerAttributeFields }) => {
  const { t } = useTranslation();
  const {
    setValue,
    formState: { errors },
    setFocus,
  } = useFormContext();

  const handleRemoveAttribute = (index: number) => {
    customerAttributeFields.remove(index);
  };
  const { attributeKey: attributeKeyError } = errors;

  const attributeKey = useWatch({
    name: 'attributeKey',
  });

  return (
    <>
      <Typography gutterBottom variant="h3">
        {t('page.customers.form.attributes.addNewAttributes')}
      </Typography>
      <IncTextField
        data-testid={'AttributeForm.IncTextField.AttributeKey'}
        name={'attributeKey'}
        label={t('page.customers.form.attributes.createAttributeKey')}
      />
      <Button
        disabled={!!attributeKeyError || !attributeKey}
        fullWidth
        size="small"
        onClick={() => {
          const elementIndex = customerAttributeFields.fields.findIndex(
            at => at.key.toUpperCase() === attributeKey.toUpperCase(),
          );
          if (elementIndex !== -1) {
            setFocus(`attributes.[${elementIndex}].value`);
          } else {
            customerAttributeFields.prepend({
              id: attributeKey.toUpperCase(),
              key: attributeKey.toUpperCase(),
              value: '',
            });
          }
          setValue('attributeKey', '');
        }}
        sx={{ textTransform: 'capitalize' }}
        data-testid={'AttributeForm.Button.AddAttribute'}
      >
        {t('page.customers.form.attributes.addAttribute')}
      </Button>
      {customerAttributeFields.fields.length > 0 && (
        <Typography gutterBottom variant="h3" sx={{ marginTop: '20px' }}>
          {t('page.customers.form.attributes.editAttributes')}
        </Typography>
      )}
      {customerAttributeFields.fields.map((attribute, index) => {
        return (
          <Fragment key={attribute.id}>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              key={attribute.id}
            >
              <IncTextField
                key={attribute.id}
                name={`attributes.[${index}].value`}
                label={attribute.key}
                data-testid={`AttributeForm.IncTextField.${attribute.key}`}
              />
              <IconButton
                data-testid="AttributeForm.IncTextField.closeButton"
                onClick={() => handleRemoveAttribute(index)}
                sx={{ ml: 1, mt: 1 }}
              >
                <CloseOutlinedIcon sx={{ color: 'error.main' }} />
              </IconButton>
            </Box>
          </Fragment>
        );
      })}
    </>
  );
};

export default AddEditAttributesForm;
